<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-仓库盘点-添加
    -->
    <el-dialog
    title="添加仓库盘点"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%" 
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
       
        <div class="common-form">盘点清单</div>   
        
  

        <el-button icon="el-icon-plus" @click="changeProduct(form.product)">选择商品</el-button>
        <el-table size="small" :data="form.product"   border style="width: 100%" v-loading="loading">
        
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="unit" label="计量单位"></el-table-column>
  
          <el-table-column prop="product_price" label="单价"> </el-table-column>
          <el-table-column prop="act_stock" label="系统库存"> </el-table-column>

          <el-table-column prop="act_num" label="实际库存">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.act_num"

                placeholder="请输入实际库存"
                type="number"
              ></el-input>

            </template>

          </el-table-column>

          <el-table-column prop="warehousekwtext" label="库区"></el-table-column>

          <el-table-column prop="note" label="备注">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.note"

                placeholder="请输入备注"
                type="text"
              ></el-input>

            </template>

          </el-table-column>
       
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>


        </el-table>

        <el-form-item label="备注：" >
          <el-input
                v-model="form.note"
                placeholder="请输入备注"
                type="text"
              ></el-input>
        </el-form-item>

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </div>
  <!-- <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="islist" @closeDialog="closeDialogFunc"></Product> -->
  <Batch :isBatch="isBatch"  :excludeIds="excludeIds" :islist="islist" @closeDialog="closeDialogFuncBatch"></Batch>
  
</el-dialog>
  
</template>

<script>

import Warehouse_inventoryApi from '@/api/warehouse_inventory.js';
import Batch from '@/components/product/batch';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Product from '@/components/product/SkuProduct';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     Batch,
     Product
  },
  data() {
    return {
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      islist:true,
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        numb:"",
        time:"",
        lossQuantity:"",
        lossAmount:"",
        gainQuantity:"",
        gainAmount:"",
        shop_user_id:"",
        product:[],
        note:"",

      },
      loading: false,
      /*验证规则*/
      rules: {},
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      isBatch:false,


      
     
    };
  },
  created() {
    console.log(11111)
  
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {

  


    del(index){
      this.form.product.splice(index,1)
    },
 
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
       /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFuncBatch(e){
      console.log('e.params',e.params)
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.product_image,
            warehouse_kw_id: item.warehouse_kw_id,
            warehousekwtext: item.warehousekwtext,
            warehousetext: item.warehousetext,
            unit: item.unit,
            spec_value:item.spec_value,
            status:0,//0 未入库 1  已入库
            set_num:1,
            file_path:item.image.file_path,
            rk:item.warehouse_management,
            category_name:item.category_name,
            batchNumber:item.batchNumber,
            act_stock:item.act_stock,
          };
          arr.push(obj)
        }
        self.form.product = self.form.product.concat(arr);
        self.form.product = mergeTable(this.form.product);
    
    }
  },
    /*打开添加*/
    changeProduct(list) {
     
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isBatch = true;
    },

    onSubmit() {
      let self = this;
      let form = self.form;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Warehouse_inventoryApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/warehouse_inventory/index/part/add.vue